import React from "react";
import styles from "./privacyPolicy.module.scss";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../footer/Footer";

const policyData = [
  {
    id: 1,
    title: "1. Information We Collect",
    description1:
      "We collect and process various types of personal information to provide better services, improve our website’s functionality, and fulfill legal and business requirements.",
    description2:
      "Personal information includes details you provide directly, such as your name, email address, phone number, and business details when filling out forms or contacting us. We also collect technical data like IP addresses, browser types, and device details when you access our site.",
  },
  {
    id: 2,
    title: "2. How We Use Your Information",
    description1:
      "We use personal information collected from various sources to provide services, communicate with clients, conduct marketing campaigns, improve website functionality, and ensure legal compliance.",
    description2:
      "This includes responding to inquiries, delivering service updates, running promotional campaigns, analyzing website performance, and preventing fraud through enhanced data security measures.",
  },
  {
    id: 3,
    title: "3. Data Sharing and Disclosure",
    description1:
      "We ensure that your personal information is only shared when necessary and in compliance with applicable legal standards.",
    description2:
      "We may share data with service providers assisting in business operations, marketing partners for promotional campaigns, legal authorities when required by law, and potential business buyers during company mergers or sales.",
  },
  {
    id: 4,
    title: "4. Social Media Lead Data Management",
    description1:
      "We run targeted ad campaigns on platforms like Facebook, LinkedIn, Instagram, and Google Ads to generate leads. This involves collecting data through lead forms filled out voluntarily by users.",
    description2:
      "Collected data is securely stored in our CRM, accessible only to authorized personnel. Users may opt-out or withdraw consent at any time by contacting us directly or following instructions in marketing emails.",
  },
  {
    id: 5,
    title: "5. Data Security",
    description1:
      "We implement robust security measures, including secure data storage, encrypted communication protocols, and restricted access based on user roles.",
    description2:
      "Our IT infrastructure includes firewalls, anti-malware solutions, and regular security audits to prevent unauthorized access, data breaches, and other cybersecurity threats.",
  },
  {
    id: 6,
    title: "6. Your Data Rights",
    description1:
      "Depending on applicable laws, you have the right to access, correct, delete, or transfer your personal data, as well as withdraw consent for marketing communications.",
    description2:
      "To exercise these rights, contact us through the provided channels. We will address your requests promptly while complying with legal and regulatory obligations.",
  },
  {
    id: 7,
    title: "7. Cookies Policy",
    description1:
      "Our website uses cookies to improve browsing experiences, enhance site functionality, and deliver personalized content. These cookies help us remember user preferences and optimize loading times.",
    description2:
      "Users can adjust cookie settings through browser preferences. Disabling cookies may limit certain website features but will not restrict basic access to our services.",
  },
  {
    id: 8,
    title: "8. Third-Party Links",
    description1:
      "Our website may include links to external sites for additional resources or service integrations. We are not responsible for the privacy practices or policies of these third-party sites.",
    description2:
      "We recommend reviewing the privacy policies of any external websites you visit through our platform to understand how they handle your personal information.",
  },
  {
    id: 9,
    title: "9. Changes to This Policy",
    description1:
      "We reserve the right to update this Privacy Policy at any time. Any changes will be reflected on this page, and the effective date will be updated accordingly.",
    description2:
      "We encourage users to review this policy periodically for updates. Continued use of our services after policy updates constitutes acceptance of the revised terms.",
  },
  {
    id: 10,
    title: "10. Contact Us",
    description1:
      "If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at:",
    // description2: "",
  },
];
const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <Navbar />
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <div className={styles.topTop}>Detailed Privacy Policy of Kriha®</div>
          <div className={styles.topMiddle}>Updated 11th December 2024</div>
          <div className={styles.topBottom}>
            Learn how Kriha IT Solutions collects, uses, and protects your data,
            including lead information from social media campaigns.
          </div>
        </div>
        <div className={styles.bottom}>
          {policyData?.map((item) => (
            <div className={styles.content}>
              <div className={styles.title}>{item?.title}</div>
              <div className={styles.descriptionWrapper}>
                <div className={styles.description}>{item?.description1}</div>
                <div className={styles.description}>{item?.description2}</div>
              </div>
            </div>
          ))}
          <div className={styles.contactWrapper}>
            <div  className={styles.contactHead}>Kriha IT Solutions</div>
            <div>Email: support@krihaitsolutions.com</div>
            <div>Phone: +91 96771 65660</div>
            <div>Address: 5, Jacob Street, Madipakkam, Chennai - 600091</div>
          </div>
        </div>
        <div></div>
      </div>
      <Footer/>
    </div>
  );
};

export default PrivacyPolicy;
